import React, { useMemo } from 'react';
import { colors, frames, glyphs } from '../../../Styles';
import { useMediaQuery } from '../../../Styles/mediaQueries';
import { Attentions, Farrowing, Feeding, InThisSystem, PageHeader, SystemControls } from '../../../Components';
import { useTranslation } from 'react-i18next';
import { SystemData } from '../../../Assets/TestData/systems';
import CardNumberDisplay from '../../../Components/BaseComponents/cardNumberDisplay';
import { Sections } from '../../../Assets/TestData/sectionsData';
import { TestData as Pens } from '../../../Assets/TestData/lf_Data';

export default function FreedaLocationFeeder() {
  const { t } = useTranslation();
  const hideCardNumberDisplays = useMediaQuery(`(max-height: 765px)`);
  
  const { systemName } = useMemo(() => {
    const systemData = SystemData.find((system) => system.systemId === 2);
    return {
      systemName: systemData?.systemName || "",
    };
  }, []);

    const numberOfSections = Sections.length;
  
    const totalNumberOfPens = Pens.length;
  
    const totalNumberOfAnimals = Pens.filter(pen => pen.animalId).length;


  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader topHeader={systemName} subHeader={t("overview")}/>
      </frames._page_inner_header>
      <frames._page_inner_content>
        {/* <div style={{display: "grid", gridTemplateColumns: "300px 210px 1fr", gridTemplateRows: "1fr 360px", height: "100%", gridColumnGap: "20px", gridRowGap: "10px", boxSizing: "border-box"}}> */}
        <div style={{display: "grid", gridTemplateColumns: "300px 1fr 210px", gridTemplateRows: "1fr 360px", height: "100%", gridColumnGap: "20px", gridRowGap: "10px", boxSizing: "border-box"}}>

          {!hideCardNumberDisplays && 
          <div style={{gridArea: "1/1/2/2"}}>
            <div style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "10px", boxSizing: "border-box"}}>
              <CardNumberDisplay value={numberOfSections} unit={'Sections'} glyph={<glyphs.AnimalGroup fillColor={colors.greySecondary} size="150px"/>}/> 
              <CardNumberDisplay value={totalNumberOfPens} unit={'Pens'} glyph={<glyphs.Condition fillColor={colors.greySecondary} size="150px"/>}/> 
              <CardNumberDisplay value={totalNumberOfAnimals} unit={'Animals'} glyph={<glyphs.Animal fillColor={colors.greySecondary} size="150px"/>}/> 
            </div>
          </div>
          }

          <div style={{gridArea: hideCardNumberDisplays ? "1/1/3/2" : "2/1/3/2"}}>
            <SystemControls/>
          </div>

          {/* <div style={{gridArea: "1/2/3/3", overflow: "hidden"}}> */}
          <div style={{gridArea: "1/3/3/4", overflow: "hidden"}}>
            <Attentions/>
          </div>

          {/* <div style={{gridArea: "1/3/3/4", paddingLeft: "20px", borderLeft: "2px solid"+colors.greyDarkPrimary, overflowY: "scroll", scrollbarColor: colors.greyDarkPrimary+colors.transparent, scrollbarWidth: "thin"}}> */}
          <div style={{gridArea: "1/2/3/3", padding: "0px 20px", borderLeft: "2px solid"+colors.greyDarkPrimary, borderRight: "2px solid"+colors.greyDarkPrimary, overflowY: "scroll", overflowX: "hidden", scrollbarColor: colors.greyDarkPrimary+colors.transparent, scrollbarWidth: "thin", display: "flex", justifyContent: "center"}}>
            <div style={{display: "flex", flexDirection: "column", gap: "20px", height: "100%"}}>
              <Feeding/>
              <Farrowing/>
            </div>
          </div>

        </div>
      </frames._page_inner_content>
    </frames.Page_inner>
  );
}